// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.responsive-table-shell {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.nowrap-table {\n  width: 100%;\n}\n.sales-table {\n  min-width: 3030px;\n}\n.nowrap-table .cell {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
